import { InputLabel } from "@mui/material";
import React from "react";
import './customInputLabel.css'

const CustomInputLabel = ({label}) => {
    return <InputLabel className="custom-input-label">{label}</InputLabel>
}

export default CustomInputLabel